// SPDX-FileCopyrightText: 2024 Sequent Tech <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql } from "@apollo/client";
export var UPDATE_REPORT = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    mutation UpdateReport($id: uuid!, $set: sequent_backend_report_set_input!) {\n        update_sequent_backend_report_by_pk(pk_columns: {id: $id}, _set: $set) {\n            id\n        }\n    }\n"], ["\n    mutation UpdateReport($id: uuid!, $set: sequent_backend_report_set_input!) {\n        update_sequent_backend_report_by_pk(pk_columns: {id: $id}, _set: $set) {\n            id\n        }\n    }\n"])));
var templateObject_1;
